module.exports = __webpack_public_path__ + "e345214c7bb62ad594c6681f5f6cb16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-7.png
// module id = 311
// module chunks = 1